import { z } from 'zod';
import { datetime } from './commons';
//====================================================
// Plan Financement event type
//====================================================
export const planFinancementEventSchema = z.object({
    type: z.string(),
    avis: z.string().optional(),
    date: z.union([datetime, z.string().date()]).optional(),
    reference: z.string().optional(),
    dateMetier: z.union([datetime, z.string().date()]).optional(),
});
export const planFinancementEventsSchema = z.array(planFinancementEventSchema);
//====================================================
// Plan Financement financeur type
//====================================================
export const planFinancementFinanceurSchema = z.object({
    href: z.string().optional(),
    organisation: z
        .object({
        id: z.string().optional(),
    })
        .optional(),
    groupesGestion: z.array(z.object({ href: z.string() })).optional(),
    source: z.object({ href: z.string().optional() }).optional(),
});
//====================================================
// Plan Financement ligne type
//====================================================
export const planFinancementLigneSchema = z.object({
    reference: z.string().optional(),
    financement: z
        .object({
        statut: z.string().optional(),
        financeur: planFinancementFinanceurSchema.optional(),
        history: z
            .object({
            events: z.array(planFinancementEventSchema).optional(),
        })
            .optional(),
        source: z
            .object({
            href: z.string().optional(),
            title: z.string().optional(),
        })
            .optional(),
    })
        .optional(),
    montant: z
        .object({
        ttc: z.number().optional(),
        ht: z.number().optional(),
    })
        .optional(),
    avisRecevabilite: z.object({}).optional(),
});
//====================================================
// Plan Financement sous poste type
//====================================================
export const planFinancementSousPosteSchema = z.object({
    reference: z.string().optional(),
    lignes: z.array(planFinancementLigneSchema).optional(),
});
//
//====================================================
// Plan Financement poste type
//====================================================
export const planFinancementPosteSchema = z.object({
    reference: z.string().optional(),
    lignes: z.array(planFinancementLigneSchema).optional(),
    sousPostes: z.array(planFinancementSousPosteSchema).optional(),
});
export const planFinancementSchema = z.object({
    recette: z
        .object({
        postes: z.array(planFinancementPosteSchema).optional(),
    })
        .optional(),
    periode: z
        .object({
        exercice: z.number(),
    })
        .optional(),
});
//# sourceMappingURL=plan-financement.js.map